module.exports = __webpack_public_path__ + "img/status-rank.e5364b69.png";